/**
 * Composition pour initialiser l'application
 * - Initialisation de VueJS, Pinia (ancien Vuex pour la gestion du store), I18n, Router
 */

import { createApp, h, defineAsyncComponent } from 'vue';
import { createPinia } from 'pinia';
import 'vue3-colorpicker/style.css';
import Vue3ColorPicker from 'vue3-colorpicker';
/***/
import i18n from '@js/i18n';
import router from '@js/core/router';

const RootComponent = defineAsyncComponent(() => import(/* webpackChunkName: "components" */ '@components/Root'));

export default function() {

    const onReady = (() => {

        // Initialisation de VueJS
        createApp({
            render: () => h(RootComponent),
        })  .use(createPinia()) // Vuex 5 as Pinia
            .use(i18n)
            .use(Vue3ColorPicker)
            .use(router)
            .mount('#app')

    });

    onReady();
};
